import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-iconos',
  templateUrl: './iconos.component.html',
  styleUrls: ['./iconos.component.scss'],
})
export class IconosComponent implements OnInit {
 @Input() name = ""
  constructor() { }

  ngOnInit() {}

}
